import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Cadastro from './components/Cadastro';
import Dashboard from './components/Dashboard/Dashboard';
import Login from './components/login/Login';
import Home from './screens/Home/Home';
import UserDashboard from './components/UserDashboard/UserDashboard';
import { useAuth } from './components/auth';
import { jwtDecode } from 'jwt-decode';

function App() {
  const { isAuthenticated, logout, user, setUser } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem('authToken');

    if (token) {
      try {
        const decoded = jwtDecode(token);

        // Se o usuário ainda não estava carregado, carregamos agora
        if (!user) {
          setUser(decoded);
        }

      } catch (error) {
        console.error('Erro ao decodificar token:', error);
        logout(); // Token inválido → força logout
      }
    }
  }, [user, setUser, logout]);

  // Proteção para Admin
  const AdminRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'admin'
      ? children
      : <Navigate to="/login" replace />;

  // Proteção para Cliente
  const UserRoute = ({ children }) =>
    isAuthenticated && user?.owner === 'user'
      ? children
      : <Navigate to="/login" replace />;

  return (
    <Routes>
      {/* Páginas públicas */}
      <Route path="/" element={<Home />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/login" element={<Login />} />

      {/* Painel do ADMIN */}
      <Route
        path="/dashboard/*"
        element={
          <AdminRoute>
            <Dashboard logout={logout} />
          </AdminRoute>
        }
      />

      {/* Painel do CLIENTE */}
      <Route
        path="/dashboard-cliente/*"
        element={
          <UserRoute>
            <UserDashboard userId={user?.id} />
          </UserRoute>
        }
      />
    </Routes>
  );
}

export default App;
